module.exports = __webpack_public_path__ + "static/media/spider2.e033d4ea.gif";